import { render, staticRenderFns } from "./Fabric.vue?vue&type=template&id=130f4177"
import script from "./Fabric.vue?vue&type=script&lang=js"
export * from "./Fabric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports